// Address validation removed - Google Places doesn't provide address verification
// This class now just passes through the address without validation

export class AddressValidate {
  constructor(options = {}) {
    this.container = options.container || document.body;
    this.onApply = options.onApply || (() => {});
    this.onDecline = options.onDecline || (() => {});
  }

  async validateAndConfirm(address) {
    // No validation - just pass through the address
    return { proceed: true, address: address };
  }

  destroy() {
    // No cleanup needed
  }
}
